import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights = undefined;

const filterCodeyTelemetry = (envelope) => {
  if (envelope.baseData.target && envelope.baseData.target.indexOf('cdn.xerius.be/style') !== -1) {
    return false;
  }
};

function init(instrumentationKey) {
  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey
    }
  });
  appInsights.addTelemetryInitializer(filterCodeyTelemetry);
}

/**
 * @returns {ApplicationInsights} ApplicationInsights
 */
const getInstance = () => appInsights;

/**
 *
 * @param {import('vue-router').Route} to
 * @param {string} windowTitle
 */
function trackRoutePageView(to, windowTitle) {
  if (!to) return;

  const ai = getInstance();
  if (ai) {
    ai.trackPageView({
      name: windowTitle,
      uri: to.path,
      properties: {
        routeName: to.name
      }
    });
  }
}

/**
 *
 * @param {string} windowTitle
 * @param {string} path
 * @param {string} routeName
 */
function trackPageView(windowTitle, path, routeName = undefined) {
  if (!windowTitle || !path) return;

  trackRoutePageView({ path, name: routeName }, windowTitle);
}

/**
 *
 * @param {string} message
 * @param {object} properties
 */
function trackTrace(message, properties) {
  if (!message) return;

  const ai = getInstance();
  if (ai) {
    ai.trackTrace({
      message,
      properties
    });
  }
}

export default {
  init,
  getInstance,
  trackRoutePageView,
  trackPageView,
  trackTrace
};
